import { Lens } from '@dhmk/zustand-lens';

import { AdditionalEmail, AdditionalPhone, Residence, SocialProfile } from '@/api/profile/queries';

export type ProfileForm = {
  id: string;
  alias: string | null;
  name: string | null;
  jobTitle: string | null;
  description: string | null;
  cvFileId: string | null;
  headshotFileId: string | null;
  /** @deprecated Migrated into `socialProfiles`. */
  linkedinProfile: string | null;
  /** @deprecated Migrated into `socialProfiles`. */
  xProfile: string | null;
  countryOfResidence: string | null;
  nationalities: string[] | null;
  phoneNumber: string | null;
  address: string | null;
  emailIsPublic: boolean;
  phoneNumberIsPublic: boolean;
  residenceIsPublic: boolean;
  eventsAttendedIsPublic: boolean;
  additionalEmails: AdditionalEmail[];
  additionalPhones: AdditionalPhone[];
  additionalResidences: Residence[];
  socialProfiles: SocialProfile[];
};

export type ProfileSlice = {
  form: ProfileForm;
  setForm: (_data: Partial<ProfileForm>) => void;
  resetState: () => void;
};

const initialState: Omit<ProfileSlice, 'setForm' | 'resetState'> = {
  form: {
    id: '',
    alias: null,
    name: null,
    jobTitle: null,
    description: null,
    cvFileId: null,
    headshotFileId: null,
    linkedinProfile: null,
    xProfile: null,
    countryOfResidence: null,
    nationalities: [],
    phoneNumber: null,
    address: null,
    emailIsPublic: false,
    phoneNumberIsPublic: false,
    residenceIsPublic: false,
    eventsAttendedIsPublic: true,
    additionalEmails: [],
    additionalPhones: [],
    additionalResidences: [],
    socialProfiles: [],
  },
};

export const profileStore: Lens<ProfileSlice> = (set) => ({
  ...initialState,
  setForm: (data) =>
    set((state) => {
      state.form = { ...state.form, ...data };
    }),
  resetState: () =>
    set((state) => {
      state.form = { ...initialState.form };
    }),
});
